import { render, staticRenderFns } from "./SelfOrderOpt.vue?vue&type=template&id=1b833393&"
import script from "./SelfOrderOpt.vue?vue&type=script&lang=js&"
export * from "./SelfOrderOpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports